import { useOutlet } from "react-router-dom";
import { DemoAuthProvider } from "@/providers/demo-auth-provider";
import { DemoDataProvider } from "@/providers/demo-data-provider";

export const DemoAuthLayout = () => {
    const outlet = useOutlet();

    return (
        <DemoAuthProvider>
            <DemoDataProvider>{outlet}</DemoDataProvider>
        </DemoAuthProvider>
    );
};
